import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asbsbtsyllabus',
    templateUrl: './asbsbtsyllabus.component.html',
    styleUrls: ['./asbsbtsyllabus.component.scss']
})
export class AsbsbtsyllabusComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
